<meta itemprop="validThrough" [content]="validThrough" />

<section *ngIf="cleanDescription" class="content__jobs" id="jobs-anchor">
  <h2 class="content__title" i18n>À propos du poste</h2>
  <p itemprop="description" class="content__jobs__end-text">{{ cleanDescription }}</p>
</section>
